// src/cert/cmmi.js
import React from 'react';
import ApplyForm from '../components/ApplyForm';
import './CertPage.css';

const CMMI = () => {
    return (
        <div className="cert-page">
            <div className="cert-header">
                <h1>CMMI प्रमाणन</h1>
                <p>क्षमता परिपक्वता मॉडेल एकीकरण (Capability Maturity Model Integration)</p>
            </div>

            <div className="cert-content">
                <section>
                    <h2>CMMI म्हणजे काय?</h2>
                    <p>
                        The service industry is a significant driver for worldwide economic growth 80% of the world's business is service-based. However, without a strong service delivery strategy, its easy to over-promise and under-deliver. Many organizations lack the ability to react quickly to incidents that impact service delivery, leading to time delays, cost overruns, and failure to meet customer expectations. CMMI Services is an integrated set of best practices that improves an organizations capability to efficiently and effectively deliver quality service offerings that meet market and customer needs.

                        Key Benefits

                        Gain Customer Loyalty exceed customer expectations and experience, strengthen weak customer touch points.

                        Develop Resiliency reduce the impact of service disruptions with a process to identify and address potential incidents and prevent them from reoccurring.

                        Improve Time-to-Market ensure services are delivered quickly, efficiently, and in accordance with established agreements.

                        Increase Quality provide the highest possible level of service quality.

                        Reduce Cost lower costs through improved planning and reduced re-work.
                    </p>
                </section>

                <section>
                    <h2>प्रमुख फायदे</h2>
                    <ul>
                        <li>प्रक्रिया सुव्यवस्थित आणि सातत्यपूर्ण होतात</li>
                        <li>प्रकल्प वेळेत, बजेटमध्ये पूर्ण होतात</li>
                        <li>गुणवत्ता, उत्पादकता आणि ग्राहक समाधान वाढते</li>
                        <li>जोखीम कमी होतात, दोष कमी होतात</li>
                        <li>जागतिक बाजारात (USA, Europe) मान्यता मिळते</li>
                    </ul>
                </section>

                <section className="apply-section">
                    <h2>CMMI साठी अर्ज करा</h2>
                    <ApplyForm certification="CMMI" />
                </section>
            </div>
        </div>
    );
};

export default CMMI;